import { MemberAnketaDescription } from './MemberAnketaDescription';

export default MemberAnketaDescription;